import { SortOrder } from '@getaccept/fried-tofu';
import type { LoadFilesPayload } from '../types/load-files-payload';
import { FileSortBy } from '../types/enums/file-sort-by';

export default class FileConstants {
  static defaultPayload: LoadFilesPayload = {
    limit: 20,
    offset: 0,
    sortOrder: SortOrder.Desc,
    sortBy: FileSortBy.PinnedAt,
    searchTerms: [],
    participantIds: [],
  };

  static sizeLimit = 50000000;
}
